import { SUCCESS } from "./constants";

export default function onSuccess(
  submit,
  callback,
  formProps = {},
  onError = () => {}
) {
  return e => {
    // We've had issues with folks clicking submit buttons multiple times thus
    // creating duplicate records. This is a final safe-guard to ensure a single
    // form can only be successfully submitted once.
    if (formProps.submitSucceeded) {
      return false;
    }
    const submitResult = submit(e);

    if (!submitResult.then) {
      return false;
    }

    return submitResult
      .then(resp => {
        if (resp === SUCCESS) {
          callback();
        }
      })
      .catch(onError);
  };
}



// WEBPACK FOOTER //
// ./app/lib/submission/onSuccess.js